import { getNodeSelectLabel } from '../nodeUtils';

export default function GotoNode({ id, data }) {
    const gotoTargetId = data?.gotoTargetId || '';
    const allNodes = typeof data?.getNodes === 'function' ? data.getNodes() : [];

    const sortedAll = allNodes
        .filter((n) => !n.data?.isStart && n.id !== 'start')
        .sort((a, b) => (a.position?.y ?? 0) - (b.position?.y ?? 0));

    const indexMap = new Map(sortedAll.map((n, i) => [n.id, i + 1]));

    const options = sortedAll
        .filter((n) => n.id !== id)
        .map((n) => ({ value: n.id, label: getNodeSelectLabel(n, indexMap.get(n.id)) }));

    return (
        <div className="mt-2 space-y-2">
            <select className="form-select w-full" value={gotoTargetId}
                onChange={(e) => data?.onChangeGoto?.(id, { gotoTargetId: e.target.value })}>
                <option value="">— Selecionar bloco —</option>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>
            {!gotoTargetId && (
                <div className="text-[9px] text-yellow-500 flex items-center gap-1">
                    <i className="fas fa-exclamation-triangle" />
                    Selecione um bloco de destino
                </div>
            )}
            <div className="text-[10px] text-gray-500">
                Redireciona o fluxo para o bloco selecionado.
            </div>
        </div>
    );
}
